const LEGACY_DRAFT_TABLE_STORAGE_KEY = 'dci-submission-draft';
const DRAFT_TABLE_STORAGE_KEY = 'dci-submission-draft-table';
const DRAFT_FORM_STORAGE_KEY = 'dci-submission-draft-form';

function clear(key) {
  localStorage.removeItem(key);
}

function restore(key, defaultValue) {
  const payload = localStorage.getItem(key);

  if (typeof payload === 'string') {
    try {
      return JSON.parse(payload);
    } catch (_) {
      clear();
    }
  }

  return defaultValue;
}

function store(key, data) {
  const payload = JSON.stringify(data);
  localStorage.setItem(key, payload);
}

function clearDraft() {
  clearDraftForm();
  clearDraftTable();
}

function hasDraft() {
  const table = restoreDraftTable();
  return table.length > 0;
}

function clearDraftTable() {
  clear(LEGACY_DRAFT_TABLE_STORAGE_KEY);
  return clear(DRAFT_TABLE_STORAGE_KEY);
}

function restoreDraftTable() {
  const legacy = restore(LEGACY_DRAFT_TABLE_STORAGE_KEY, []);
  return restore(DRAFT_TABLE_STORAGE_KEY, legacy);
}

function storeDraftTable(data) {
  return store(DRAFT_TABLE_STORAGE_KEY, data);
}

function clearDraftForm() {
  return clear(DRAFT_FORM_STORAGE_KEY);
}

function restoreDraftForm() {
  return restore(DRAFT_FORM_STORAGE_KEY, {});
}

function storeDraftForm(data) {
  return store(DRAFT_FORM_STORAGE_KEY, data);
}

export {
  clearDraft,
  clearDraftForm,
  clearDraftTable,
  hasDraft,
  restoreDraftForm,
  restoreDraftTable,
  storeDraftForm,
  storeDraftTable,
};
